<template>
  <div class="reports">
    <dash-header
      :pages="breadCrumbsPages"
      :dashboardTitle="'Combined Reviews & Summaries'"
    />
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="4"
        :menuItems="commonMenuItems.admin"
        v-if="userRole === 'telas_telas_administrator'"
      />
      <dash-sidebar
        defaultSelectedKeys="3"
        :menuItems="commonMenuItems.assessors"
        v-if="
          userRole === 'telas_interim_reviewers' ||
          userRole === 'telas_admin_reviewers' ||
          userRole === 'telas_certified_reviewers'
        "
      />
      <a-layout>
        <a-layout-content
          :style="{
            margin: '24px 16px',
            padding: '24px',
            background: '#fff',
            minHeight: '280px',
          }"
        >
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Assigned" key="1">
              <a-table
                :columns="assignedColumns"
                :rowKey="(record) => record.report_id"
                :dataSource="assingedReports"
              >
                <router-link
                  slot="parent_course_title"
                  slot-scope="title, reportObj"
                  :to="{
                    name: 'report-detail',
                    params: {
                      reportId: reportObj.report_id,
                    },
                  }"
                >
                  <template v-if="reportObj.reassessment[0]">
                    Reassessment of {{ title }}
                  </template>
                  <template v-else>
                    {{ title }}
                  </template>
                </router-link>
              </a-table>
            </a-tab-pane>
            <a-tab-pane key="2">
              <a-badge
                slot="tab"
                :count="pendingReports.length"
                v-if="pendingReports"
                title="You have a pending review."
              >
                <span style="padding-right: 10px">In-progress</span>
              </a-badge>
              <span slot="tab" v-else>In-progress</span>
              <a-table
                :columns="inProgressColumns"
                :rowKey="(record) => record.report_id"
                :dataSource="inProgressReports"
              >
                <router-link
                  slot="parent_course_title"
                  slot-scope="title, reportObj"
                  :to="{
                    name: 'report-detail',
                    params: {
                      reportId: reportObj.report_id,
                    },
                  }"
                >
                  <span v-if="reportObj.is_pending === 'yes'">
                    <a-icon
                      slot="count"
                      type="exclamation-circle"
                      style="color: #f5222d"
                    />
                    <template v-if="reportObj.reassessment[0]">
                      Reassessment of {{ title }}
                    </template>
                    <template v-else>
                      {{ title }}
                    </template>
                  </span>
                  <span v-else>
                    <template v-if="reportObj.reassessment[0]">
                      Reassessment of {{ title }}
                    </template>
                    <template v-else>
                      {{ title }}
                    </template>
                  </span>
                </router-link>
              </a-table>
            </a-tab-pane>
            <a-tab-pane tab="Completed" key="3">
              <a-table
                :columns="completedColums"
                :rowKey="(record) => record.report_id"
                :dataSource="completedReports"
              >
                <router-link
                  slot="parent_course_title"
                  slot-scope="title, reportObj"
                  :to="{
                    name: 'report-detail',
                    params: {
                      reportId: reportObj.report_id,
                    },
                  }"
                >
                  <template v-if="reportObj.reassessment[0]">
                    Reassessment of {{ title }}
                  </template>
                  <template v-else>
                    {{ title }}
                  </template>
                </router-link>
              </a-table>
            </a-tab-pane>
            <a-tab-pane tab="Comparative" key="4">
              <a-table
                :columns="completedColums"
                :rowKey="(record) => record.report_id"
                :dataSource="allReports"
              >
                <router-link
                  slot="parent_course_title"
                  slot-scope="title, reportObj"
                  :to="{
                    name: 'comparative-summary',
                    params: {
                      reportId: reportObj.report_id,
                    },
                  }"
                >
                  <template v-if="reportObj.reassessment[0]">
                    Reassessment of {{ title }}
                  </template>
                  <template v-else>
                    {{ title }}
                  </template>
                </router-link>
              </a-table>
            </a-tab-pane>
            <a-tab-pane tab="Summaries" key="5">
              <a-table
                :columns="summaryColumns"
                :rowKey="(record) => record.report_id"
                :dataSource="accreditedReports"
              >
                <template slot="summary-link" slot-scope="title, reportObj">
                  <router-link
                    :to="{
                      name: 'report-summary',
                      params: {
                        reportId: reportObj.report_id,
                      },
                    }"
                  >
                    <a-tag color="green">Summary Report </a-tag>
                  </router-link>
                </template>

                <router-link
                  slot="parent_course_title"
                  slot-scope="title, reportObj"
                  :to="{
                    name: 'report-summary',
                    params: {
                      reportId: reportObj.report_id,
                    },
                  }"
                >
                  <template v-if="reportObj.reassessment[0]">
                    Reassessment of {{ title }}
                  </template>
                  <template v-else>
                    {{ title }}
                  </template>
                </router-link>
              </a-table>
            </a-tab-pane>
            <a-tab-pane tab="Accredited" key="6">
              <a-table
                :columns="accreditedColumns"
                :rowKey="(record) => record.report_id"
                :dataSource="accreditedReports"
              >
                <template slot="acc-report-link" slot-scope="title, reportObj">
                  <router-link
                    :to="{
                      name: 'report-detail',
                      params: {
                        reportId: reportObj.report_id,
                      },
                    }"
                  >
                    <a-tag color="green">Accreditation Report </a-tag>
                  </router-link>
                </template>
                <router-link
                  slot="parent_course_title"
                  slot-scope="title, reportObj"
                  :to="{
                    name: 'report-detail',
                    params: {
                      reportId: reportObj.report_id,
                    },
                  }"
                >
                  <template v-if="reportObj.reassessment[0]">
                    Reassessment of {{ title }}
                  </template>
                  <template v-else>
                    {{ title }}
                  </template>
                </router-link>
              </a-table>
            </a-tab-pane>
            <a-tab-pane
              tab="Interim"
              key="7"
              v-if="userRole === 'telas_telas_administrator'"
            >
              <a-table
                :columns="interimColumns"
                :rowKey="(record) => record.report_id"
                :dataSource="testAccreditationReports"
              >
                <router-link
                  slot="parent_course_title"
                  slot-scope="title, reportObj"
                  :to="{
                    name: 'report-detail',
                    params: {
                      reportId: reportObj.report_id,
                    },
                  }"
                >
                  <template v-if="reportObj.reassessment[0]">
                    Reassessment of {{ title }}
                  </template>
                  <template v-else>
                    {{ title }}
                  </template>
                </router-link>
              </a-table>
            </a-tab-pane>
          </a-tabs>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import dashSidebar from "./Sidebar.vue";
import dashHeader from "./Header.vue";

export default {
  name: "reports",
  components: {
    dashSidebar,
    dashHeader,
  },
  data() {
    return {
      breadCrumbsPages: [
        {
          name: "Home",
          route: "/",
        },
        {
          name: "Dashboard",
          route: "/dashboard",
        },
        {
          name: "Reports",
          route: "/dashboard/reports",
        },
      ],
      accreditedColumns: [
        {
          title: "Course Title",
          dataIndex: "parent_course_title",
          sorter: false,
          scopedSlots: { customRender: "parent_course_title" },
        },
        {
          title: "First Reviewer Name",
          dataIndex: "first_reviewer_name",
        },
        {
          title: "Second Reviewer Name",
          dataIndex: "second_reviewer_name",
        },
        {
          title: "Accreditation Date",
          dataIndex: "completion_date",
          sorter: false,
          scopedSlots: { customRender: "completion_date" },
        },
        {
          title: "",
          dataIndex: "acc-report-link",
          sorter: false,
          scopedSlots: { customRender: "acc-report-link" },
        },
      ],
      inProgressColumns: [
        {
          title: "Course Title",
          dataIndex: "parent_course_title",
          sorter: false,
          scopedSlots: { customRender: "parent_course_title" },
        },
        {
          title: "First Reviewer Name",
          dataIndex: "first_reviewer_name",
        },
        {
          title: "Second Reviewer Name",
          dataIndex: "second_reviewer_name",
        },
        {
          title: "Commencement Date",
          dataIndex: "commencement_date",
          sorter: false,
          scopedSlots: { customRender: "commencement_date" },
        },
      ],
      assignedColumns: [
        {
          title: "Course Title",
          dataIndex: "parent_course_title",
          sorter: false,
          scopedSlots: { customRender: "parent_course_title" },
        },
        {
          title: "First Reviewer Name",
          dataIndex: "first_reviewer_name",
        },
        {
          title: "Second Reviewer Name",
          dataIndex: "second_reviewer_name",
        },
        {
          title: "Assigned Date",
          dataIndex: "assigned_date",
          sorter: false,
          scopedSlots: { customRender: "commencement_date" },
        },
      ],
      interimColumns: [
        {
          title: "Course Title",
          dataIndex: "parent_course_title",
          sorter: false,
          scopedSlots: { customRender: "parent_course_title" },
        },
        {
          title: "Interim Reviewer Name",
          dataIndex: "first_reviewer_name",
        },
        {
          title: "Assigned Date",
          dataIndex: "assigned_date",
          sorter: false,
          scopedSlots: { customRender: "commencement_date" },
        },
        {
          title: "Status",
          dataIndex: "assessment_status",
          sorter: false,
        },
      ],
      summaryColumns: [
        {
          title: "Course Title",
          dataIndex: "parent_course_title",
          sorter: false,
          scopedSlots: { customRender: "parent_course_title" },
        },
        {
          title: "First Reviewer Name",
          dataIndex: "first_reviewer_name",
        },
        {
          title: "Second Reviewer Name",
          dataIndex: "second_reviewer_name",
        },
        {
          title: "Completed Date",
          dataIndex: "completion_date",
          sorter: false,
          scopedSlots: { customRender: "completion_date" },
        },
        {
          title: "",
          dataIndex: "summery-link",
          sorter: false,
          scopedSlots: { customRender: "summery-link" },
        },
      ],
      completedColums: [
        {
          title: "Course Title",
          dataIndex: "parent_course_title",
          sorter: false,
          scopedSlots: { customRender: "parent_course_title" },
        },
        {
          title: "First Reviewer Name",
          dataIndex: "first_reviewer_name",
        },
        {
          title: "Second Reviewer Name",
          dataIndex: "second_reviewer_name",
        },
        {
          title: "Completed Date",
          dataIndex: "completion_date",
          sorter: false,
          scopedSlots: { customRender: "completion_date" },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("user", {
      userRole: "getUserRole",
    }),
    ...mapGetters("user", {
      userId: "getUserId",
    }),
    // ...mapState("user", {
    //   userId: (state) => state.userDetails.user_id,
    // }),
    ...mapGetters("reports", {
      assingedReports: "assignedReportMeta",
      inProgressReports: "inProgressReportMeta",
      completedReports: "completedReportMeta",
      accreditedReports: "accreditedReportMeta",
      testAccreditationReports: "testAccreditationReportMeta",
      allReports: "allReportMeta",
      pendingReports: "pendingReports",
    }),
  },
  watch: {
    userId: {
      handler: function (newVal) {
        if (newVal !== undefined) {
          this.fetchReports("in-progress");
          this.fetchReports("assigned");
          this.fetchReports("fortest");
          this.fetchReports("accredited");
          this.fetchReports("completed");
          this.fetchReports();
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("reports", {
      getCombinedReports: "getCombinedReports",
      getReports: "getReports",
    }),
    fetchReports(reviewStatus) {
      console.log(this.userId);
      let getReportsArgs = {
        "filter[meta_query][0][key]": "review_status",
        "filter[meta_query][0][value]": reviewStatus,
        reviewStatus,
      };
      getReportsArgs =
        reviewStatus === "fortest"
          ? {
              "filter[meta_query][0][key]": "for_test",
              "filter[meta_query][0][value]": "yes",
              reviewStatus,
            }
          : getReportsArgs;
      getReportsArgs =
        this.userRole !== "telas_telas_administrator"
          ? {
              ...getReportsArgs,
              ...{
                "filter[meta_query][1][key]": "reviewers_assigned",
              },
              ...{ "filter[meta_query][1][value]": this.userId },
              ...{ "filter[meta_query][1][compare]": "LIKE" },
            }
          : getReportsArgs;
      getReportsArgs =
        reviewStatus !== "fortest"
          ? {
              ...getReportsArgs,
              ...{ "filter[meta_query][2][key]": "for_test" },
              ...{ "filter[meta_query][2][value]": "yes" },
              ...{
                "filter[meta_query][2][compare]": "NOT EXISTS",
              },
            }
          : getReportsArgs;
      if (reviewStatus === "completed" && this.userRole !== "telas_telas_administrator") {
        getReportsArgs = {
          ...getReportsArgs,
          "filter[meta_query][0][key]": "assessment_status",
          "filter[meta_query][0][value]": "complete",
          "filter[meta_query][1][key]": "reviewers_assigned",
          "filter[meta_query][1][value]": this.userId,
          "filter[meta_query][1][compare]": "LIKE",
          reviewStatus,
        };
      } else if (
        reviewStatus === "completed" &&
        this.userRole === "telas_telas_administrator"
      ) {
        getReportsArgs = {
          ...getReportsArgs,
          "filter[meta_query][0][key]": "assessment_status",
          "filter[meta_query][0][value]": "complete",
          reviewStatus,
        };
      }
      this.getReports(getReportsArgs);
    },
  },
  //   mounted() {
  //     this.fetchReports("in-progress");
  //     this.fetchReports("assigned");
  //     this.fetchReports("fortest");
  //     this.fetchReports("accredited");
  //     this.fetchReports("completed");
  //     this.fetchReports();
  //   },
};
</script>
